import { render, staticRenderFns } from "./init-tabs.vue?vue&type=template&id=c3b655d6"
import script from "./init-tabs.vue?vue&type=script&lang=js"
export * from "./init-tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports